import { NavConfig } from '../data/constants/nav';
import { NavLinkConfig, NavLinkId } from '../data/types/nav';
import { TxNameCode } from '../data/types/tx';

const migratedLinks = (...linkIds: NavLinkId[]) =>
  linkIds.reduce(
    (acc, id) => ({ ...acc, [id]: NavConfig.linkConfigs[id] }),
    {} as Partial<Record<NavLinkId, NavLinkConfig>>
  );
// DEV/LOCAL use dev links
export const devMigratedLinks = migratedLinks(
  'MN_ADDENDUM_C',
  'TX_DAILY_TRANS_BULLETIN',
  'TX_INJURED_INACTIVE_REHAB',
  'TX_TAXI_SQUAD',
  'TX_PLAYER_TRACKING',
  'TX_PIEF_LIST',
  'TX_PIEF_LIST_FORM',
  'TX_ELECT_FREE_AGENCY_XX_B_',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_INFO_UTILITY',
  'RSTR_MJ_MN_ROSTERS',
  'SYS_BATCHES',
  'SYS_EMAILS',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'ADVANCED_SEARCH',
  'CLIPBOARD',
  'E_SIGNATURE',
  'RSTR_TWO_WAY_PLAYERS',
  'MJ_AWARD_BONUS_PACKAGES',
  'AWARD_BONUS_PACKAGE',
  'MN_VERIFICATION',
  'MN_DRAFT_CONTRACTS',
  'MN_ASSIGNMENT',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'INT_WLP_CLUB_COMMS',
  'PROFILE_PRO_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'EMP_ROSTERS',
  'EMP_DOCTORS',
  'EMP_TRANSLATORS',
  'EMP_PERMISSION_REQUESTS',
  'EMP_PERMISSION_REQUEST',
  'INT_DRUG_TEST_REQUESTS',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'R4_ADMIN',
  'R4_SCHOOLS',
  'R4_SCHOOL',
  'R4_DRAFT_LIVE',
  'R4_DRAFT_DAY_BOC',
  'R4_BOC_PLAYER_LISTING',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_EMP_HISTORY',
  'PROFILE_EMP_CONTRACTS',
  'CEP_PLAYERS',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'RSTR_ELIGIBLE_FOR_DUGOUT',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_DRAFT_ORDER',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'RSTR_DETAILS',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA',
  'PROFILE_PRO_INFO',
  'PROFILE_INT_AMA_CONTRACTS_AND_INV',
  'PROFILE_INT_AMA_CONTRACTS',
  'PROFILE_INT_AMA_INFO',
  'INT_NEW_PLAYER',
  'TX_IL_RECERTIFICATION',
  'TRANSACTION',
  'PROFILE_INT_AMA_SUMMARY',
  'MJ_AWARD_ENTRY',
  'MJ_CENTRAL_TENDER',
  'MJ_CENTRAL_TENDER_UTILITY',
  'MJ_ARB_ELIGIBLES',
  'PROFILE_WV_AND_TX',
  'PROFILE_SERVICE',
  'TX_TRANSACTION_PAYMENTS',
  'PROFILE_PRO_INTERNATIONAL',
  'PROFILE_DRAFT_AND_SCOUTING',
  'PROFILE_STATS',
  'CSP',
  'CSP_INVOICE',
  'CSP_CREDIT',
  'UTIL_FILE_ATTACHMENTS',
  'PROFILE_EMP_INFO',
  'PROFILE_EMP_SUMMARY',
  'PROFILE_EMP_CONTRACTS_AND_INV',
  'PROFILE_INT_AMA_SCOUTING',
  'R4_PRE_DRAFT',
  'R4_DRAFT_ORDER',
  'MJ_CBT_PAYORS',
  'PROFILE_DOM_AMA',
  'R4_NEW_PLAYER',
  'PROFILE_DOM_AMA_SUMMARY',
  'CEP',
  'CEP_INVOICE',
  'CEP_CREDIT',
  'PROFILE_DOM_AMA_SCOUTING',
  'PROFILE_DOM_AMA_CONTRACTS',
  'PROFILE_DOM_AMA_CONTRACTS_AND_INV',
  'INT_FOREIGN_LEAGUE_REQUESTS'
);

// STG/TRN/BF/PROD use prod links
export const prodMigratedLinks = migratedLinks(
  'MN_DRAFT_CONTRACTS',
  'MN_ADDENDUM_C',
  'TX_INJURED_INACTIVE_REHAB',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_MJ_MN_ROSTERS',
  'RSTR_TWO_WAY_PLAYERS',
  'TX_PLAYER_TRACKING',
  'TX_PIEF_LIST',
  'TX_PIEF_LIST_FORM',
  'SYS_BATCHES',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'ADVANCED_SEARCH',
  'MN_VERIFICATION',
  'MN_ASSIGNMENT',
  'EMP_ROSTERS',
  'EMP_PERMISSION_REQUESTS',
  'EMP_PERMISSION_REQUEST',
  'PROFILE_PRO_HISTORY',
  'PROFILE_EMP_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'CEP_PLAYERS',
  'CLIPBOARD',
  'INT_DRUG_TEST_REQUESTS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'INT_WLP_CLUB_COMMS',
  'R4_DRAFT_LIVE',
  'R4_DRAFT_DAY_BOC',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'TX_TAXI_SQUAD',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_DRAFT_ORDER',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_EMP_CONTRACTS',
  'TX_PLAYER_TRACKING',
  'TX_DAILY_TRANS_BULLETIN',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA',
  'PROFILE_INT_AMA_CONTRACTS_AND_INV',
  'PROFILE_INT_AMA_CONTRACTS',
  'PROFILE_INT_AMA_INFO',
  'INT_NEW_PLAYER',
  'PROFILE_INT_AMA_SUMMARY',
  'MJ_AWARD_BONUS_PACKAGES',
  'E_SIGNATURE',
  'SYS_EMAILS',
  'RSTR_DETAILS',
  'TRANSACTION',
  'PROFILE_PRO_INFO',
  'TX_ELECT_FREE_AGENCY_XX_B_',
  'R4_SCHOOLS',
  'R4_SCHOOL',
  'PROFILE_PRO_INTERNATIONAL',
  'PROFILE_WV_AND_TX',
  'PROFILE_SERVICE',
  'PROFILE_STATS',
  'PROFILE_DRAFT_AND_SCOUTING',
  'TX_IL_RECERTIFICATION',
  'TX_TRANSACTION_PAYMENTS',
  'UTIL_FILE_ATTACHMENTS',
  'MJ_AWARD_ENTRY',
  'MJ_ARB_ELIGIBLES',
  'RSTR_ELIGIBLE_FOR_DUGOUT',
  'PROFILE_EMP_SUMMARY',
  'PROFILE_EMP_INFO',
  'PROFILE_EMP_CONTRACTS_AND_INV',
  'CSP',
  'CSP_INVOICE',
  'CSP_CREDIT',
  'PROFILE_INT_AMA_SCOUTING',
  'R4_PRE_DRAFT',
  'PROFILE_DOM_AMA',
  'PROFILE_DOM_AMA_SUMMARY',
  'PROFILE_DOM_AMA_SCOUTING',
  'PROFILE_DOM_AMA_CONTRACTS',
  'PROFILE_DOM_AMA_CONTRACTS_AND_INV',
  'R4_NEW_PLAYER',
  'CEP',
  'CEP_INVOICE',
  'CEP_CREDIT',
  'MJ_ARB_ELIGIBLES',
  'MJ_CBT_PAYORS',
  'MJ_CENTRAL_TENDER',
  'MJ_CENTRAL_TENDER_UTILITY',
  'R4_ADMIN',
  'R4_DRAFT_ORDER'
);

export const devMigratedTx: TxNameCode[] = [
  'MJSEL',
  'RELES',
  'TRANS',
  'FADML',
  'MNOUT',
  'WNTRQ',
  'WBCRQ',
  'EEWBCRQ',
  'IL10J',
  'IL07J',
];

export const prodMigratedTx: TxNameCode[] = [
  'MJSEL',
  'RELES',
  'TRANS',
  'FADML',
  'MNOUT',
  'WNTRQ',
  'IL10J',
  'IL07J',
  'WBCRQ',
  'EEWBCRQ',
];
